import skyTheme from '@skycell-ag/theme'
import {
    Theme,
} from '@mui/material'

const skyNetTheme = skyTheme as Theme

const theme = {
    ...skyNetTheme,
    components: {
        MuiTimeClock: {
            styleOverrides: {
                root: {
                    justifyContent: 'center',
                },
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                row: {
                    backgroundColor: skyNetTheme.palette.common.white,
                    '&:hover': {
                        backgroundColor: skyNetTheme.palette.primary[30],
                    },
                },
                columnHeader: {
                    color: skyNetTheme.palette.secondary[700],
                },
                cell: {
                    display: 'flex',
                    alignItems: 'center',
                    color: skyNetTheme.palette.common.black,
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                filled: {
                    backgroundColor: skyNetTheme.palette.secondary[200],
                },
            },
        },
    },
}

export default theme
